import { QuestionnaireListCompactDto } from "@common/dto/questionnaire/list-compact-dto";
import React from "react";
import { getFhq4Questionnaires } from "../services/questionnaires";

export type QuestionnairesControllerProps = {
  showErrorMessage: (msg: string) => void;
};

export const useQuestionnairesController = (props: QuestionnairesControllerProps) => {
  const { showErrorMessage } = props;
  const [questionnaires, setQuestionnaires] = React.useState<Array<QuestionnaireListCompactDto>>([]);
  const [questionnairesLoading, setQuestionnairesLoading] = React.useState<boolean>(false);

  const getAndSetQuestionnaires = React.useCallback(async () => {
    try {
      setQuestionnairesLoading(true);
      const quests = await getFhq4Questionnaires({ includeFamily: true });
      setQuestionnaires(quests);
      return quests;
    } finally {
      setQuestionnairesLoading(false);
    }
  }, [showErrorMessage]);

  const addQuestionnaireToList = React.useCallback((questionnaire: QuestionnaireListCompactDto) => {
    setQuestionnaires((prev) => [questionnaire, ...prev]);
  }, []);

  const removeQuestionnaireFromList = React.useCallback((questionnaireId: QuestionnaireListCompactDto['questionnaireId']) => {
    setQuestionnaires((prev) => prev.filter((q) => q.questionnaireId !== questionnaireId));
  }, []);

  return {
    removeQuestionnaireFromList,
    addQuestionnaireToList,
    questionnaires,
    questionnairesLoading,
    getAndSetQuestionnaires,
  };
};